import { FunctionComponent } from 'react';
import MaintenanceState from '@rio-cloud/rio-uikit/lib/es/MaintenanceState';

const UnderConstruction: FunctionComponent = () => (
    <MaintenanceState headline="Under Construction" message="Hier wird noch gearbeitet." />
);
export default UnderConstruction;
